import { styled } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DescriptionHeader, DescriptionText, TextContainer } from 'src/components/ErrorMessage';
import { LoadingSpinner } from 'src/components/Loading';

const StyledProcessingStateContents = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};
`;
export function CADProcessingState({ productName, children }: Readonly<{ productName: string; children: ReactNode }>) {
  const { t } = useTranslation('createProduct');

  return (
    <>
      <LoadingSpinner />
      <StyledProcessingStateContents>
        <TextContainer>
          <DescriptionHeader>{t('workingOnCADFile', { productName })}</DescriptionHeader>
          <DescriptionText>{t('freeToLeaveThisPage')}</DescriptionText>
          <DescriptionText>{t('youCanComeBackSoon')}</DescriptionText>
        </TextContainer>
        {children}
      </StyledProcessingStateContents>
    </>
  );
}
